import { Component, Input, Inject } from '@angular/core';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-modify-existing-entity-field-value',
    templateUrl: './side-effect-modify-existing-entity-field-value.html',
    standalone: false
})
export class SideEffectModifyEntityFieldValueComponent {
    _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.CollectionName = this._seConfiguration.CollectionName || '';
        this._seConfiguration.PartitionKey = this._seConfiguration.PartitionKey || '';
        this._seConfiguration.IdentifyingFieldPath = this._seConfiguration.IdentifyingFieldPath || '';
        this._seConfiguration.IdentifyingFieldValue = this._seConfiguration.IdentifyingFieldValue || '';
        this._seConfiguration.PropertyToReplacePath = this._seConfiguration.PropertyToReplacePath || '';
        this._seConfiguration.ValueToSave = this._seConfiguration.ValueToSave || '';
        this._seConfiguration.TypeOfValueToSave = this._seConfiguration.TypeOfValueToSave || 0;
        this._seConfiguration.ValueToSaveIsCurrentDateTime = this._seConfiguration.ValueToSaveIsCurrentDateTime || false;

    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;
    }
}
